import { initI18n } from '@jove-frontend/uikit';
import { resources } from '../locales';

export const initialI18n = (lng = 'en') => {
  initI18n({
    defaultNS: 'common',
    ns: ['common', 'home'],
    resources,
    lng,
  });
};
